// @ts-expect-error Not typed yet
import EmailAddressRegex from 'PatternValidationJS/patterns/EmailAddress';
import { INVALID, VALID } from '../PropertyValidationStatus';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { INVALID_EMAIL_FORMAT } from '../PropertyValidationErrorCodes';
import { jsx as _jsx } from "react/jsx-runtime";
const isNotHubspotSupportEmail = email => {
  return !/(support\.hubspot\.com)/g.test(email);
};
const isValidEmail = email => {
  if (email === '' || email === undefined || email === null) {
    return true;
  }
  return EmailAddressRegex.test(email) && isNotHubspotSupportEmail(email);
};
const createValidationDetails = validationRequest => {
  const isValid = isValidEmail(validationRequest.value);
  const errors = isValid ? [] : [{
    code: INVALID_EMAIL_FORMAT,
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.propertyValidationErrorMessages.invalidEmailFormat"
    })
  }];
  return {
    errors,
    validationRequest,
    validationStatus: isValid ? VALID : INVALID
  };
};

/**
 * Validator for ensuring strings have the correct format to be an email address
 * This validator should work for any email address property. If a property
 * requires a more specific validation a new custom validator should be used.
 */
export const emailPropertyValidator = validationRequest => Promise.resolve(createValidationDetails(validationRequest));